import React from "react";
import "./StudentCourseCommonSection.css";

const FEATURES = [
  "未経験でも大丈夫。入学した方の90%以上が未経験です。",
  "最新の生成AI技術を活用した効率的な学習",
  "企業・自治体との実務実習でリアルな経験を積める",
  "メタバース空間での実践的な授業環境",
];

const STATS = [
  { icon: "person", lead: "90%以上", sub: "未経験者" },
  { icon: "clock",  lead: "1-2年",   sub: "学習期間" },
  { icon: "book",   lead: "実務中心", sub: "カリキュラム" },
];

function Icon({ name }) {
  const c = "currentColor";
  switch (name) {
    case "check":
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0-18 0Z"/>
          <path fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                d="M8 12l3 3l5-6"/>
        </svg>
      );
    case "person":
      return (
        <svg width="32" height="32" viewBox="0 0 24 24" aria-hidden="true">
          <g fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="7" r="3.5" />
            <path d="M4 20c0-3.3 3.3-6 8-6s8 2.7 8 6" />
          </g>
        </svg>
      );
    case "clock":
      return (
        <svg width="32" height="32" viewBox="0 0 24 24" aria-hidden="true">
          <g fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v6l4 2" />
          </g>
        </svg>
      );
    case "book":
      return (
        <svg width="32" height="32" viewBox="0 0 24 24" aria-hidden="true">
          <g fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 5a3 3 0 0 1 3-3h11v16H7a3 3 0 0 0-3 3z" />
            <path d="M7 2v16" />
          </g>
        </svg>
      );
    default:
      return null;
  }
}

export default function StudentCourseCommonSection() {
return (
	<div className="courseCommon" aria-labelledby="courseCommon-title">
		<h2 id="courseCommon-title" className="courseCommon__title">全コース共通の特徴</h2>

		<div className="courseCommon__grid">
			{/* LEFT */}
			<div className="courseCommon__left">
				<ul className="courseCommon__features">
					{FEATURES.map((t, i) => (
						<li key={i} className="courseCommon__featureItem">
							<span className="courseCommon__check" aria-hidden="true">
								<Icon name="check" />
							</span>
							<span className="courseCommon__featureText">{t}</span>
						</li>
					))}
				</ul>

				<div className="courseCommon__styleCard" role="note" aria-label="学習スタイル">
					<h3 className="courseCommon__styleTitle">学習スタイル</h3>
					<p className="courseCommon__styleText">
						インプットはいつでもどこでも。<br/>
			アウトプットはガッツリ現場で（メタバース）。
					</p>
				</div>
			</div>

			{/* RIGHT */}
			<div className="courseCommon__right">
				<div className="courseCommon__stats">
					{STATS.map((s, i) => (
						<div className="courseCommon__stat" key={i}>
							<span className="courseCommon__statIcon" aria-hidden="true">
								<Icon name={s.icon} />
							</span>
							<div className="courseCommon__statLead">{s.lead}</div>
							<div className="courseCommon__statSub">{s.sub}</div>
						</div>
					))}
				</div>

				<div className="courseCommon__panel">
					<h3 className="courseCommon__panelTitle">全コース共通</h3>
					<p className="courseCommon__panelText">
						どのコースを選んでも、メタバース空間での実践的な学習と、
						企業・自治体との連携による実務実習が受けられます。
					</p>
					<a
						className="courseCommon__cta"
						href="https://calendar.app.google/eGWCC8qBvVumb2DWA"
						target="_blank"
						rel="noopener noreferrer"
					>
						無料相談を予約する
					</a>
				</div>
			</div>
		</div>
	</div>
);
}
